import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from '../base.entity';

/**
 * Join table: groups visible to a team. A conversation with
 * visibility=team is accessible (read + post) by any member of any
 * team referenced here. Posting auto-creates a chat_participant row.
 *
 * Multiple rows per conversation → union across teams. Multiple rows
 * per team → one team can gate many conversations.
 */
@Entity('chat_conversation_team')
@Index('idx_chat_conversation_team_convo', ['conversationId'])
@Index('idx_chat_conversation_team_team', ['teamId'])
@Index('uq_chat_conversation_team', ['conversationId', 'teamId'], {
	unique: true,
})
export class ChatConversationTeamEntity extends BaseEntity {
	@Column('int', {
		name: 'fk_chat_conversation__id',
		unsigned: true,
	})
	public conversationId!: number;

	@Column('int', {
		name: 'fk_team__id',
		unsigned: true,
	})
	public teamId!: number;
}
